import { graphql, useStaticQuery } from "gatsby";
import { HomepageMetricsQuery } from "./query.generated";

export type CMSMetricsData = HomepageMetricsQuery["cms"]["site"];

export function useStaticMetricsQuery(): CMSMetricsData {
  const data = useStaticQuery<HomepageMetricsQuery>(
    graphql`
      query HomepageMetrics {
        cms {
          site(hostname: "www.italymondo.com") {
            page(slug: "italymondo") {
              ... on CMS_ItalyMondoHomePage {
                metrics {
                  metric {
                    name
                    value
                  }
                }
              }
            }
          }
        }
      }
    `
  );
  return data.cms.site;
}
